export interface RatePremiumDetails {
  premiumSequences: any[];
  _modelName: string;
  _modelVersion: string;
  rateAggregates: RateAggregate[];
  _type: string;
  _variation: string;
  _key: RatePremiumDetailsKey;
  _modelType: string;
  _timestamp: string;
}

export interface RatePremiumDetailsKey {
  rootId: string;
  revisionNo: number;
  variation: string;
}

export interface RateAggregate {
  currencyCd?: string;
  accessTrackInfo: AccessTrackInfo;
  _modelVersion: string;
  _type: string;
  _key: RatePremiumKey;
  _modelType: string;
  ratePremiumEntry: RatePremiumEntry;
  rateTypeCd: string;
  _modelName: string;
  _timestamp: string;
  packageCd?: string;
  rateEntries?: any[];
}

export interface RatePremiumKey {
  rootId: string;
  revisionNo: number;
  id: string;
  parentId: string;
  variation: string;
}

export interface AccessTrackInfo {
  updatedBy: string;
  createdBy: string;
  _type: string;
  updatedOn: string;
  _key: RatePremiumKey;
  createdOn: string;
}

export interface RatePremiumEntry {
  _type: string;
  _key: RatePremiumKey;
  policy: RateAggregatePolicy;
}

export interface RateAggregatePolicy {
  situsState?: string;
  rateEffectiveDate?: string;
  plans: RateAggregatePolicyPlan[];
  _type: string;
  policyNumber?: string;
  requestDate?: string;
  rateCardPremium?: ClassRateCardPremium;
  _key: RatePremiumKey;
  numberOfLives?: number;
}

export interface RateAggregatePolicyPlan {
  planIndex?: number;
  _type: string;
  planName: string;
  rateCardPremium?: ClassRateCardPremium;
  _key: RatePremiumKey;
  numberOfLives?: number;
  coverages: RateAggregatePlanCoverage[];
}

export interface RateAggregatePlanCoverage {
  payrollFrequency?: string;
  rateFormat?: string;
  classes: RateAggregatePlanCoverageClass[];
  _type: string;
  rateBasis?: string;
  rateCardPremium?: ClassRateCardPremium;
  _key: RatePremiumKey;
  numberOfLives?: number;
  coverageCode: string;
  coverageType?: string;
}

export interface RateAggregatePlanCoverageClass {
  tiers: RateAggregateClassTier[];
  _type: string;
  rateCardPremium?: ClassRateCardPremium;
  ageBandedRateCards?: Array<Partial<{ageBand: string; tobacco: string; rateCard: {rate: number, payrollFrequencyRate: number}; _key: {id: string}}>>;
  className: string;
  _key: RatePremiumKey;
  numberOfLives?: number;
  classNumber: string;
  rateCard?: {
    payrollFrequencyRate: number;
  };
}

export interface ClassRateCardPremium {
  annualPremium: AnnualPremium;
  premiumHolderCode: string;
  _type: string;
  _key: RatePremiumKey;
  payrollFrequencyPremium: AnnualPremium;
  monthlyPremium: AnnualPremium;
}

export interface AnnualPremium {
  amount: number;
  currency: string;
}

export interface RateAggregateClassTier {
  rateCard: RateCard;
  tier: TierEnum;
  _type: string;
  rateCardPremium?: TierRateCardPremium;
  _key: RatePremiumKey;
  ageBandRateCalc: AgeBandRateCalcType[];
}

export interface RateCard {
  participantPaid100Rate?: AnnualPremium;
  rate?: number;
  groupPaidRate?: AnnualPremium;
  _type: string;
  _key: RatePremiumKey;
  numberOfLivesDecimal?: number;
  participantPaidRate?: AnnualPremium;
}

export interface TierRateCardPremium {
  payrollFrequencyRate: AnnualPremium;
  annualPremium: AnnualPremium;
  participantPaid100AnnualRate: AnnualPremium;
  premiumHolderCode: TierEnum;
  _type: string;
  participantPaidPayrollFrequencyPremium: AnnualPremium;
  participantPaidPayrollFrequencyRate: AnnualPremium;
  _key: RatePremiumKey;
  groupPaidAnnualPremium: AnnualPremium;
  groupPaidPayrollFrequencyRate: AnnualPremium;
  participantPaidAnnualPremium: AnnualPremium;
  payrollFrequencyPremium: AnnualPremium;
  groupPaidPayrollFrequencyPremium: AnnualPremium;
  monthlyPremium: AnnualPremium;
}

export interface AgeBandRateCardPremium {
  payrollFrequencyRate: AnnualPremium;
  annualPremium: AnnualPremium;
  participantPaid100AnnualRate: AnnualPremium;
  premiumHolderCode: TierEnum;
  _type: string;
  participantPaidPayrollFrequencyPremium: AnnualPremium;
  participantPaidPayrollFrequencyRate: AnnualPremium;
  _key: RatePremiumKey;
  payrollFrequency: string;
  groupPaidAnnualPremium: AnnualPremium;
  groupPaidPayrollFrequencyRate: AnnualPremium;
  participantPaidAnnualPremium: AnnualPremium;
  payrollFrequencyPremium: AnnualPremium;
  groupPaidPayrollFrequencyPremium: AnnualPremium;
  monthlyPremium: AnnualPremium;
}

export enum TierEnum {
  Family = 'Family',
  Individual = 'Individual',
  IndividualAndChildren = 'IndividualAndChildren',
  IndividualAndSpouse = 'IndividualAndSpouse',
}

export const TIER_LOOK_UP: Record<TierEnum, string> = {
  Individual: 'Participant Only',
  IndividualAndSpouse: 'Participant + Spouse',
  IndividualAndChildren: 'Participant + Children',
  Family: 'Family',
};

export interface AgeBandRateCalcType {
  rateCard: RateCard;
  _type: string;
  rateCardPremium: AgeBandRateCardPremium;
  ageBand: string;
  _key: RatePremiumKey;
  tobaccoClass: string;
}
